module.exports = __webpack_public_path__ + "_/public/catch-logo.png?f97dfb81";


//////////////////
// WEBPACK FOOTER
// ../public/catch-logo.png
// module id = 407
// module chunks = 0